const faqs = [
  {
    q: '蘑菇影视需要付费吗？资源画质如何？',
    a: '蘑菇影视完全免费，所有资源均可在线观看无需任何费用。我们提供高清、超清、4K、蓝光等多种画质选择，满足不同设备和网络环境下的观影需求，确保您享受极致的视觉体验。',
  },
  {
    q: '观看过程中会有广告吗？播放是否流畅？',
    a: '蘑菇影视承诺全程无广告干扰，纯净观影体验。我们采用先进的CDN加速技术和自适应码率方案，确保播放流畅不缓冲，即使在网络一般的情况下也能稳定观看高清内容。',
  },
  {
    q: '蘑菇影视支持哪些设备观看？',
    a: '蘑菇影视完美适配电脑、平板和手机等全终端设备。无论您使用Windows、Mac、iOS还是Android系统，均可通过浏览器直接访问观看，无需下载任何软件，即开即看。',
  },
  {
    q: '影视资源更新频率怎么样？有最新热门内容吗？',
    a: '蘑菇影视每日更新海量影视资源，涵盖最新上映的电影、热播电视剧、高分综艺和经典动漫等。我们与各大内容平台保持同步，确保您第一时间观看到最新最热的高清影视内容。',
  },
  {
    q: '如何找到我想看的影片？有分类和搜索吗？',
    a: '蘑菇影视提供完善的分类导航和专题推荐功能。您可以通过类型筛选（动作、科幻、喜剧、悬疑、动漫等）、画质筛选（4K、蓝光、超清、高清）或榜单浏览快速发现感兴趣的影片，也可以通过专题合集探索更多精彩内容。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-500">关于蘑菇影视，您想了解的都在这</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer select-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </div>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}